module.exports = __webpack_public_path__ + "static/media/11-6.59982bd2.mp3";